import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "switch_off",
  "use": "switch_off-usage",
  "viewBox": "0 0 14 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 15\" id=\"switch_off\"><path d=\"M11.58 2.712a.75.75 0 0 0-.981 1.136A5.48 5.48 0 0 1 12.499 8c0 3.033-2.468 5.5-5.5 5.5a5.506 5.506 0 0 1-5.5-5.5 5.48 5.48 0 0 1 1.9-4.152.75.75 0 1 0-.981-1.136A6.99 6.99 0 0 0 0 8c0 3.86 3.141 7 7 7s7-3.14 7-7a6.98 6.98 0 0 0-2.42-5.288M7 8.75A.75.75 0 0 0 7.75 8V1a.75.75 0 0 0-1.5 0v7c0 .414.336.75.75.75\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol